import { Text, UnstyledButton } from '@mantine/core';
import classes from './ProfileFieldListItem.module.css';
import { useDisclosure } from '@mantine/hooks';
import { UpdatePatientInput } from '@/lib/graphql/types';
import { FunctionComponent } from 'react';
import EditFormDefault from './EditUserFormDrawer/EditUserForms/EditUserFormDefault';
import EditFormWithCode from './EditUserFormDrawer/EditUserForms/EditUserFormWithCode';
import EditUserFormAddresses from './EditUserFormDrawer/EditUserForms/EditUserFormAddresses';
import { ProfileFieldActionDrawer } from './ProfileFieldActionDrawer/ProfileFieldActionDrawer';
import Icon from '@/components/Icon';

const FIELD_FORM: {
  [key: string]:
    | FunctionComponent<{
        label: string;
        valueName: keyof UpdatePatientInput;
        onClose: () => void;
        index?: number;
      }>
    | undefined;
} = {
  preferredName: EditFormDefault,
  pronouns: EditFormWithCode,
  genderIdentity: EditFormWithCode,
  addresses: EditUserFormAddresses,
};

interface ProfileFieldListItemProps {
  label: string;
  value?: string | null;
  actionIcon?: React.ReactNode;
  onActionClick?: () => void;
  valueName?: keyof UpdatePatientInput;
  customDrawer?: React.ReactNode;
  index?: number;
}

const ProfileFieldListItem = ({
  label,
  value,
  actionIcon,
  onActionClick,
  valueName,
  customDrawer,
  index,
}: ProfileFieldListItemProps) => {
  const [openEditForm, { toggle }] = useDisclosure(false);

  const FormComponent = FIELD_FORM[String(valueName)];

  return (
    <li className={classes.root}>
      <div className={classes.item}>
        <h3 className={classes.label}>{label}</h3>
        {value ? (
          <Text className={classes.value} truncate>
            {value}
          </Text>
        ) : (
          <span
            className={classes.value}
            aria-label="Not specified"
            title="Not specified">
            --
          </span>
        )}
      </div>
      {(onActionClick || FormComponent || actionIcon) && (
        <UnstyledButton
          className={classes.editButton}
          aria-label={`Edit ${label}`}
          onClick={onActionClick || toggle}>
          {actionIcon ?? <Icon name="custom/edit-2" size="sm" />}
        </UnstyledButton>
      )}
      {FormComponent && valueName && (
        <ProfileFieldActionDrawer opened={openEditForm} onClose={toggle}>
          <FormComponent
            label={label}
            valueName={valueName}
            onClose={toggle}
            index={index}
          />
        </ProfileFieldActionDrawer>
      )}

      {customDrawer}
    </li>
  );
};

export default ProfileFieldListItem;
